import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Specs',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'specs',
                },
              },
              subqueries: {
                specs: {
                  filter: {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      {
                        '=': [
                          { '@.': ['!project', { ref: { entity: '!proj' } }] },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!specs:!spec',
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                or: [
                  { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                  {
                    '=': [
                      { '@.': ['!project', { ref: { entity: '!proj' } }] },
                      {
                        '@>': [
                          { '`': { '``': { '@$': 'projectId' } } },
                          'recordId',
                        ],
                      },
                    ],
                  },
                ],
              },
              sort: {
                by: {
                  '@.': '!id',
                },
              },
              target: 'ent:!specs:!spec',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      spec: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      title: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      approval: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'approvalMergedAt',
                                    },
                                    null,
                                  ],
                                },
                                'approved',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'approvalMergeState',
                                    },
                                    'open',
                                  ],
                                },
                                'in review',
                              ],
                              'draft',
                            ],
                          },
                        },
                      },
                      approvalPullRequest: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@': 'approvalPullRequest',
                              },
                              '—',
                            ],
                          },
                        },
                      },
                      requirements: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'requirements',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                approvalPullRequest: {
                  ref: {
                    attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                  },
                  target: 'ent:!pull_requests:!pull_request',
                  selection: {
                    '@.': '!code',
                  },
                },
                approvalMergeState: {
                  ref: {
                    attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                  },
                  target: 'ent:!pull_requests:!pull_request',
                  selection: {
                    '@.': '!merge_state',
                  },
                },
                approvalMergedAt: {
                  ref: {
                    attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                  },
                  target: 'ent:!pull_requests:!pull_request',
                  selection: {
                    '@.': '!merged_at',
                  },
                },
                requirements: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!spec',
                  },
                  target: 'ent:!requirements:!requirement',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'spec',
                  direct: {
                    '{}': {
                      name: 'Spec',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'title',
                  direct: {
                    '{}': {
                      name: 'Title',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'approval',
                  direct: {
                    '{}': {
                      name: 'Approval',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'approvalPullRequest',
                  direct: {
                    '{}': {
                      name: 'Approval PR',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requirements',
                  direct: {
                    '{}': {
                      name: 'Requirements',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
